import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceVendorId, EmployeeId, EmployeeScheduleId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, employeeScheduleKeys, toast } from '@petseo/shared';

interface DeleteScheduleParams {
  serviceVendorId: ServiceVendorId;
  serviceVendorEmployeeId: EmployeeId;
  scheduleId: EmployeeScheduleId;
}

export const useDeleteSchedule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ serviceVendorId, serviceVendorEmployeeId, scheduleId }: DeleteScheduleParams) => {
      const response = await serviceVendorsClient.deleteScheduleEndpoint(serviceVendorId, serviceVendorEmployeeId, scheduleId);
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, serviceVendorEmployeeId }) => {
      queryClient.invalidateQueries({ queryKey: employeeScheduleKeys.forEmployee(serviceVendorId, serviceVendorEmployeeId) });
      toast.success(TOAST_MESSAGES.SCHEDULE_DELETED);
    },
    onError: () => toast.error(TOAST_MESSAGES.SCHEDULE_DELETE_ERROR),
  });
};
